import LegalLayout from "./LegalLayout";

export default function Support() {
  return (
    <LegalLayout>
      <h1>Soporte</h1>
      <p className="legalLead">
        ¿Tienes un problema con la app o alguna duda sobre su
        funcionamiento? Escríbenos y te responderemos lo antes posible.
      </p>

      <h2>Contacto</h2>
      <p>
        <a href="mailto:imetropolis@metropoliscom.com">
          imetropolis@metropoliscom.com
        </a>
      </p>

      <h2>Antes de escribir</h2>
      <p>
        Para ayudarte más rápido, incluye en tu correo:
      </p>
      <ul>
        <li>Tu nombre y el de tu departamento.</li>
        <li>Qué estabas intentando hacer cuando ocurrió el problema.</li>
        <li>Modelo de tu dispositivo y sistema operativo (iOS/Android).</li>
      </ul>
    </LegalLayout>
  );
}
